// Angular Core Imports
import { Component, Input, OnInit } from '@angular/core';

// Data Models
import { ProductGroup } from '../../../../core/models/client';

@Component({
    selector: 'app-product-onboarding-ivr-row',
    templateUrl: './product-onboarding-ivr-row.component.html',
    styleUrls: ['./product-onboarding-ivr-row.component.scss'],
    standalone: true
})
export class ProductOnboardingIvrRowComponent implements OnInit {
  @Input() product: ProductGroup;

  constructor() { }

  ngOnInit() {
  }

}
